import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  notification,
  Row,
  Spin,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { CheckOutlined } from '@ant-design/icons';
import { useGetSubscriptionMutation } from '../slices/subscriptionApiSlice';
import { setSubscriptions } from '../slices/subscriptionSlice';
import { useGetSubMutation } from '../slices/usersApiSlice';
import moment from 'moment-timezone';

const SubscriptionScreen = () => {
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);
  const { subscription } = useSelector((state) => state.subscription);
  const [getSubscription, { isLoading: isSubLoading }] = useGetSubscriptionMutation();
  const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [subid, setSubid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btloading, setBtloading] = useState(false);
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const { Title, Text } = Typography;

  const getSubscriptiondata = async () => {
    try {
      const res = await getSubscription().unwrap();
      dispatch(setSubscriptions({ ...res }));
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  const getMysub = async () => {
    try {
      const res = await getmySub().unwrap();
      setCurrentPlan(res.subscription);
      setSubid(res.subid);
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  useEffect(() => {
    getSubscriptiondata();
    getMysub();
  }, []);

  // const checkoutHandler = async (amount, name, id) => {
  //   setBtloading(true);
  //   axios.defaults.withCredentials = true;

  //   const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/getkey`);
  //   const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/checkout`, {
  //     amount, id
  //   });

  //   const options = {
  //     key: key,
  //     amount: order.amount,
  //     currency: "INR",
  //     name: name,
  //     description: "Lincfolio Subscription Plan",
  //     image: "http://localhost:3000/logo.png",
  //     order_id: order.id,
  //     callback_url:` ${process.env.REACT_APP_BACKEND}/api/v1/payment/paymentverification`,
  //     prefill: {
  //       name: userInfo.firstname + ' ' + userInfo.lastname,
  //       email: userInfo.email,
  //     },
  //     theme: {
  //       color: "#2f3640"
  //     }
  //   };
  //   const razor = new window.Razorpay(options);
  //   razor.open();
  //   setBtloading(false);
  // };

  const checkoutHandler = async (amount, name, id) => {
    setLoadingPlanId(id); // set loading for that specific plan
    try {
      axios.defaults.withCredentials = true;

      const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/getkey`);
      const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/checkout`, {
        amount, planId:id
      });

      const options = {
        key: key,
        amount: order.amount,
        currency: "INR",
        name: name,
        description: "Lincfolio Subscription Plan",
        image: "https://testapp.lincfolio.com//logo.png",
        order_id: order.id,
        callback_url: ` ${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/paymentverification`,
        prefill: {
          name: userInfo.firstname + ' ' + userInfo.lastname,
          email: userInfo.email,
        },
        theme: {
          color: "#2f3640"
        }
      };
      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      notification.error({ message: 'Subscription failed' });
    } finally {
      setLoadingPlanId(null);
    }
  };




  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: darkmode ? "#1f1f1f" : "#ffffff",
        color: darkmode ? "#f0f0f0" : "#000000",
        minHeight: "100vh",
        borderRadius: "5px",
      }}
    >
      {contextHolder}

      <Row>
        <Col flex={"auto"}>
          <Breadcrumb
            items={[{ title: 'Dashboard' }, { title: 'My Subscriptions' }]}
            style={{ marginBottom: "5px", color: darkmode ? "#f0f0f0" : "#000" }}
          />
        </Col>
      </Row>

      <Divider style={{ borderColor: darkmode ? "#555" : undefined }} />

      {ismyLoading ? (
        <Spin tip="Loading current subscription...">
          <div style={{ height: '200px' }} />
        </Spin>
      ) : (
        <>
          {currentPlan && currentPlan.status !== "deactive" ? (
            <Alert
              message={`You are currently subscribed to the ${subid?.name}`}
              description={`Status: ${currentPlan.status} | Next Billing Date: ${moment(currentPlan.endDate).format("DD-MMM-YYYY")}`}
              type="success"
              showIcon
              style={{
                backgroundColor: darkmode ? "#333" : "#f6ffed",
                color: darkmode ? "#ffffff" : undefined,
                border: darkmode ? "1px solid #555" : undefined,
                marginBottom: '1rem',
              }}
            />
          ) : (
            <Alert
              message="You are not currently subscribed to any plan."
              type="warning"
              showIcon
              style={{
                backgroundColor: darkmode ? "#444" : undefined,
                color: darkmode ? "#ffffff" : undefined,
                border: darkmode ? "1px solid #666" : undefined,
                marginBottom: '1rem',
              }}
            />
          )}

          <Divider orientation="left" style={{ fontFamily: 'Cormorant, serif', color: darkmode ? "#ffffff" : "#000", fontSize: "20px" }}>
            Available Plans
          </Divider>

          <Row gutter={[16, 16]}>
            {subscription != null && subscription.map((plan) => (
              <Col xs={24} sm={12} md={8} key={plan.name}>
              <Card
  bordered={false}
  style={{
    backgroundColor: "#275f3c",
    color: darkmode ? "#ffffff" : "#000000",
    border: currentPlan?.plan_id === plan._id ? '2px solid #9D7F3B' : '',
    boxShadow: darkmode
      ? '0 4px 20px rgba(255, 255, 255, 0.1)'
      : '0 4px 20px rgba(0, 0, 0, 0.1)',
    borderRadius: '24px',
    padding: '47px',
    height: '350px',
    display: 'flex',
    flexDirection: 'column',
  }}
  bodyStyle={{ padding: '0', display: 'flex', flexDirection: 'column', flex: 1 }}
>
  {/* Title and Highlights */}
  <div style={{ flex: 1 }}>
    <div style={{ textAlign: 'center', marginBottom: '10px' }}>
      <div
        style={{
          fontFamily: 'Michroma',
          fontSize: '24px',
          color: '#fff',
        }}
      >
        {plan.name}
      </div>
      <div
        style={{
          fontFamily: 'Cormorant',
          fontWeight: 600,
          color: '#D1A954',
          fontSize: '14px',
        }}
      >
        {plan.tagline}
      </div>
    </div>

    <ul
      style={{
        paddingLeft: '20px',
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        color: '#ffffff',
        lineHeight: '1.8',
        marginBottom: 0,
      }}
    >
      {plan?.highlights?.[0] && <li>{plan.highlights[0]}</li>}
      {plan?.highlights?.[1] && (
        <li style={{ color: '#facc15' }}>{plan.highlights[1]}</li>
      )}
      {plan?.highlights?.[2] && <li>{plan.highlights[2]}</li>}
      {plan?.highlights?.[3] && <li>{plan.highlights[3]}</li>}
    </ul>
  </div>

  {/* Button aligned at the bottom */}
  <div style={{ textAlign: 'center', marginTop: 'auto' }}>
{currentPlan?.planId?.toString() === plan.id?.toString() ? (
      <Button
        icon={<CheckOutlined />}
        disabled
        style={{
          borderColor: "#9D7F3B",
          borderRadius: "9999px",
          color: darkmode ? "#f1f4f2ff" : "#f0f4f1ff",
          backgroundColor: "#D1A954",
          minWidth: "160px",
          height: "48px",
          fontFamily: 'Cormorant, serif',
        }}
      >
        CURRENT PLAN
      </Button>
    ) : (
      <Button
        type="primary"
        style={{
          backgroundColor: "#D1A954",
          color: "#fff",
          fontFamily: 'Cormorant, serif',
          border: "none",
          borderRadius: "9999px",
          padding: "8px 24px",
          fontSize: "20px",
          minWidth: "160px",
          height: "48px",
        }}
        loading={loadingPlanId === plan._id}
        onClick={() => checkoutHandler(plan.price * 100, plan.name, plan.id)}
      >
        {plan.price > 0 ? `SUBSCRIBE` : 'SUBSCRIBE FOR FREE'}
      </Button>
    )}
  </div>
</Card>

              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );
};

export default SubscriptionScreen;




